var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferLetterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4344 7.51677L18.8371 8.11407L19.4344 7.51677L15.1449 3.22731L14.5277 3.84452L15.1449 3.22731C14.8175 2.89993 14.3735 2.716 13.9105 2.716H6.85267C6.15817 2.716 5.49212 2.99189 5.00104 3.48297C4.50995 3.97405 4.23407 4.64011 4.23407 5.3346V19.3005C4.23407 19.995 4.50995 20.661 5.00104 21.1521C5.49212 21.6432 6.15817 21.9191 6.85267 21.9191H17.3271C18.0216 21.9191 18.6876 21.6432 19.1787 21.1521C19.6698 20.661 19.9457 19.995 19.9457 19.3005V8.75119C19.9457 8.28819 19.7617 7.84416 19.4344 7.51677Z",
    stroke: "white",
    strokeWidth: 1.74573
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5806 13.1846H8.59766",
    stroke: "white",
    strokeWidth: 1.74573
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5806 16.6836H8.59766",
    stroke: "white",
    strokeWidth: 1.74573
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3434 9.69043H8.59766",
    stroke: "white",
    strokeWidth: 1.74573
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferLetterIcon);
export default __webpack_public_path__ + "static/media/OfferLetterIcon.c6613d8ce3ef6d34dcda2f37fdb24dab.svg";
export { ForwardRef as ReactComponent };